/**
 * Returns a formatted string describing how long ago a date was
 * in minutes, hours, yesterday, or days ago.
 *
 * @param {Date} pastDate - The date/time you want to compare to now.
 * @returns {string} - A string describing how long ago it was.
 */
export function getTimeDifference(pastDate: Date) {
  const now = new Date();
  const diffInMs = now.getTime() - pastDate.getTime();

  // Convert difference to other units
  const diffInMinutes = Math.floor(diffInMs / 1000 / 60);
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);
  const diffInYears = Math.floor(diffInDays / 365);

  // Within 60 minutes
  if (diffInMinutes < 60) {
    // 1 minute or minutes
    return diffInMinutes <= 1 ? '1 minute ago' : `${diffInMinutes} minutes ago`;
  }

  // Within 24 hours
  if (diffInHours < 24) {
    return diffInHours === 1 ? '1 hour ago' : `${diffInHours} hours ago`;
  }

  // Check if it was "yesterday"
  if (diffInDays === 1) {
    return 'yesterday';
  }

  // Less than a year
  if (diffInYears < 1) {
    return diffInDays === 1 ? '1 day ago' : `${diffInDays} days ago`;
  }

  // More than a year
  return diffInYears === 1 ? 'more than 1 year ago' : `more than ${diffInYears} years ago`;
}
